import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdatePartnerQuestionnaireRequestSchema,
  TUpdatePartnerQuestionnaireResponseSchema,
} from "./updatePartnerQuestionnaire.schema";

export const updatePartnerQuestionnaire = (axios: IAxiosInstance) => {
  return async (data: TUpdatePartnerQuestionnaireRequestSchema) => {
    const {
      partner_id,
      business_model_description,
      expected_volume_and_scale,
      payment_and_funds_flow_description,
      sensitive_data_handling,
      questionnaire_attestation,
      security_documents,
    } = data;

    const formData = new FormData();
    formData.append("business_model_description", business_model_description);
    formData.append("expected_volume_and_scale", expected_volume_and_scale);
    formData.append(
      "payment_and_funds_flow_description",
      payment_and_funds_flow_description
    );
    formData.append("sensitive_data_handling", sensitive_data_handling);
    formData.append(
      "questionnaire_attestation",
      questionnaire_attestation.toString()
    );
    security_documents?.forEach((document) => {
      formData.append("security_documents", document);
    });

    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePartnerQuestionnaireResponseSchema>
    >(`/api/partners/${partner_id}/questionnaire`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
